export default __webpack_public_path__ + "static/color-picker-example-light-e6c406c11463c4e27bdedad037cf23839e09401a0366f8d1e7b0aad657887c19.png";